export default [
  {
    path: "/user-manual",
    name: "UserManual",
    component: () => import("./views/UserManualView.vue"),
    props: true
  },

];
